<template>
  <div class="container-fluid single-category-300">
    <div class="row">

      <div class="col-12 my-4">
        <div class="row">
          <div class="col-lg-4 single-category-image-section my-3">
            <img class="col-lg-12 single-category-300-image" :src="category.image" :alt="category.name">
          </div>
          <div class="col-lg-8 single-category-text-section my-3">
            <h3 class="single-category-300-title">{{ category.name }}</h3>
            <div v-if="category.description != null" v-html="category.description"
                 class="single-category-300-description"></div>
          </div>

        </div>
      </div>


      <div class="container">
        <div class="col text-center">
          <h3 v-t="`category.single.category_items_title`"></h3>
        </div>
        <hr>

        <div class="row" id="single-category-archive-300">

          <div class="col-lg-3 mt-3" v-for="product in products" :key="product.id">
            <m-product-card309 :product="product"/>
          </div>


        </div>

        <div class="row text-center mt-3 ">
          <div class="col-lg-12">
            <m-paginate1 :meta="meta" :onChangePage="changePage"/>
          </div>
        </div>


        <div v-if="relatedPosts">
          <h3 class="text-center" v-t="`category.single.related_content`"></h3>
          <m-content-archive3 content-type="post" :content-category="categoryLink"
                              category-column-prop="slug"/>
        </div>


      </div>


    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import router from "@/router";
import mProductCard309 from "../../Product/Card/ProductCard309";
import mPaginate1 from "../../Pagination/Paginate1";
import {resetFilters} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter'
import mContentArchive3 from "../../Content/Archive/ContentArchive3";

export default {
  name: "SingleCategory300",
  components: {mProductCard309, mPaginate1, mContentArchive3},
  props: {
    categoryLink: {
      default: null
    },
    relatedPosts: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapGetters({
      category: 'Category/getCategory',
      products: "Product/getProducts",
      meta: "Product/getPaginationMeta",
      IsAuthenticated: "User/isAuthenticated",
    })
  },
  methods: {
    resetFilters,
    changePage(page) {
      this.$store.dispatch('Product/setProducts', page);
      router.push({name: "SingleCategory", query: {...router.currentRoute.query, page: page}})
    },
    categoryLinkMethod() {
      if (this.categoryLink !== null) {
        return this.categoryLink;
      }
      return this.$route.params.slug
    }
  },
  async mounted() {
    this.resetFilters();
    await this.$store.dispatch('Category/getCategory', this.categoryLinkMethod())
  },
  watch: {
    category: {
      handler(newCategory, oldCategory) {
        this.resetFilters();
        this.$store.commit('Product/setFilters', {key: "category", value: [newCategory.id]});
        this.$store.dispatch('Product/setProducts');
      },
      deep: true
    },
  }
};
</script>

<style>

#single-category-archive-300 .product-card .price-now {
  color: black !important;
}
</style>

<style scoped>

</style>